<!-- Confirm -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- Message -->
<p-toast>
  <ng-template let-message pTemplate="message">
    <div class="p-grid p-ml-2">
      <div class="p-col-2">
        <i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
      </div>
      <div class="p-col-10">
        <h4>{{message.summary}}</h4>
      </div>
      <div class="p-col-12">
        <p>{{message.detail}}</p>
      </div>
      <div *ngIf="message.severity!='success'" class="p-col-12">
        <a class="p-button"
          href="mailto:{{env_supportmail}}?subject=Fehlermeldung%20VION&amp;body={{message.summary}}%0A%0A{{message.detail}}%0D%0A%0D%0AName:%0D%0AEmail:%0D%0ATelefon:%0D%0AKommentar:%0D%0A%0D%0A%0D%0AZum%20besseren%20Verständnis%20wenn%20möglich%20bitte%20Screenshots%20beifügen.">
          Fehler melden
        </a>
      </div>
    </div>
  </ng-template>
</p-toast>

<!-- Spinner -->
<div *ngIf="loading!==0" class="spinner">
  <span class="ball-1"></span>
  <span class="ball-2"></span>
  <span class="ball-3"></span>
  <span class="ball-4"></span>
  <span class="ball-5"></span>
  <span class="ball-6"></span>
  <span class="ball-7"></span>
  <span class="ball-8"></span>
</div>


<div class="flex justify-content-center">
  <div class="grid grid-cols-12 gap-4">
    <div>
      <button type="button" pButton icon="fa fa-plus"
        class="p-button-success p-mr-2" pTooltip="{{'BUTTONS.NEW' | translate }}"
        tooltipPosition="bottom" (click)="createEvent()"></button>
      <button
        class="btn btn-primary"
        (click)="setView(CalendarView.Day)"
        [class.active]="view === CalendarView.Day"
        class="p-mr-2 p-ripple p-button p-component"
      >
        {{ 'CALENDAR.DAY' | translate }}
      </button>
      <button
        class="btn btn-primary"
        (click)="setView(CalendarView.Week)"
        [class.active]="view === CalendarView.Week"
        class="p-mr-2 p-ripple p-button p-component"
      >
        {{ 'CALENDAR.WEEK' | translate }}
      </button>
      <button
        class="btn btn-primary"
        (click)="setView(CalendarView.Month)"
        [class.active]="view === CalendarView.Month"
        class="p-mr-2 p-ripple p-button p-component"
      >
        {{ 'CALENDAR.MONTH' | translate }}
      </button>
      
      <h3 style="float: right; margin: 0;">{{ viewDate | calendarDate:(view + 'ViewTitle'):locale }}</h3>
    </div>
    <div style="display: flex; justify-content: center;">
      <div>
        <div
          class="btn btn-primary"
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
          class="p-mr-2 p-ripple p-button p-component p-button-icon-only"
        >
          <i class="pi pi-arrow-left"></i>
        </div>
        <div
          class="btn btn-outline-secondary"
          mwlCalendarToday
          [(viewDate)]="viewDate"
          class="p-mr-2 p-ripple p-button p-component"
        >
          {{ 'CALENDAR.TODAY' | translate }}
        </div>
        <div
          class="btn btn-primary"
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
          class="p-mr-2 p-ripple p-button p-component p-button-icon-only"
        >
          <i class="pi pi-arrow-right"></i>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
</div>
<div [ngSwitch]="view" style="margin-left: 5%; margin-right: 5%;">
  <mwl-calendar-month-view
    [weekStartsOn]="weekStartDay"
    *ngSwitchCase="CalendarView.Month"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [activeDayIsOpen]="activeDayIsOpen"
    (dayClicked)="dayClicked($event.day)"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
    [locale]="locale"
    [cellTemplate]="customCellTemplate"
  >
  </mwl-calendar-month-view>
  <mwl-calendar-week-view
    [weekStartsOn]="weekStartDay"
    *ngSwitchCase="CalendarView.Week"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
    [locale]="locale"
		[hourDuration]="120"
		[hourSegments]="1"
  >
  </mwl-calendar-week-view>
  <mwl-calendar-day-view
    [weekStartsOn]="weekStartDay"
    *ngSwitchCase="CalendarView.Day"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
    [locale]="locale"
		[hourDuration]="60"
		[hourSegments]="1"
  >
  </mwl-calendar-day-view>
</div>

<p-dialog header="{{ modalTitle }}" [modal]="true" [(visible)]="showModal" [style]="{ width: '50rem', 'max-width': '100%' }">
  <div class="p-grid">
    <div class="p-col-12">
      <label class="ml-2">{{ 'CALENDAR.TITLE' | translate }}</label>
      <input
        type="text"
        [(ngModel)]="modalEventTitle"
        pInputText
        [style.width]="'100%'"
        [style]="{'max-width':'100%'}"
        [disabled]="isDetailViewMode()"
      />
    </div>
    <div class="p-col-8">
      <label>{{ 'CALENDAR.TYPE' | translate }}</label>
      <br>
      <p-dropdown
        class="dropdown-button-group"
        [style]="{'width':'100%'}"
        [(ngModel)]="modalEventTypeId"
        [options]="eventOptions"
        [optionValue]="'id'"
        [optionLabel]="'label'"
        [showClear]="true"
        [virtualScroll]="true"
        itemSize="30"
        [filter]="true"
        appendTo="body"
        dropdownDirective
        [disabled]="isDetailViewMode()"
      ></p-dropdown>
    </div>
    <div class="p-col-4">
      <label>{{ 'CALENDAR.ALL_DAY' | translate }}</label>
      <br>
      <p-inputSwitch
        [(ngModel)]="modalAllDay"
        (ngModelChange)="updateDuration()"
        [disabled]="isDetailViewMode()"
      ></p-inputSwitch>
    </div>
    <div *ngIf="modalAllDay"
      class="p-grid"
      [style]="{'margin':'0'}"
    >
      <div class="p-col-4">
        <label class="ml-2">{{ 'CALENDAR.DATE_START' | translate }}</label>
        <p-calendar [showIcon]="true" dateFormat="dd.mm.yy" keepInvalid="true"
          [(ngModel)]="modalDateStart"
          (ngModelChange)="updateDurationMatchEnd()"
          appendTo="body"
          [style]="{'width':'100%'}"
          [touchUI]="isMobile"
          [showClear]="false"
          [disabled]="isDetailViewMode()"
          [showWeek]="showWeek"
          [firstDayOfWeek]="weekStartDay"
        >
        </p-calendar>
      </div>
      <div class="p-col-4">
        <label class="ml-2">{{ 'CALENDAR.DATE_END' | translate }}</label>
        <p-calendar [showIcon]="true" dateFormat="dd.mm.yy" keepInvalid="true"
          [(ngModel)]="modalDateEnd"
          (ngModelChange)="updateDuration()"
          appendTo="body"
          [style]="{'width':'100%'}"
          [touchUI]="isMobile"
          [showClear]="false"
          [disabled]="isDetailViewMode()"
          [showWeek]="showWeek"
          [firstDayOfWeek]="weekStartDay"
        >
        </p-calendar>
      </div>
      <div class="p-col-4">
        <label class="ml-2">{{ 'CALENDAR.DURATION' | translate }}</label>
        <input
          type="text"
          [(ngModel)]="modalTotalDuration"
          pInputText
          [style.width]="'100%'"
          [style]="{'max-width':'100%'}"
          [disabled]="true"
        />
      </div>
    </div>
    <div *ngIf="!modalAllDay"
      class="p-grid"
      [style]="{'margin':'0'}"
    >
      <div class="p-col-4">
        <label class="ml-2">{{ 'CALENDAR.DATE_START' | translate }}</label>
        <p-calendar [showIcon]="true" dateFormat="dd.mm.yy" keepInvalid="true"
          [(ngModel)]="modalDateStart"
          (ngModelChange)="updateDurationMatchEnd()"
          appendTo="body"
          [showTime]="true"
          [hourFormat]="24"
          [style]="{'width':'100%'}"
          [touchUI]="isMobile"
          [showClear]="false"
          [disabled]="isDetailViewMode()"
          [showWeek]="showWeek"
          [firstDayOfWeek]="weekStartDay"
        >
        </p-calendar>
      </div>
      <div class="p-col-4">
        <label class="ml-2">{{ 'CALENDAR.DATE_END' | translate }}</label>
        <p-calendar [showIcon]="true" dateFormat="dd.mm.yy" keepInvalid="true"
          [(ngModel)]="modalDateEnd"
          (ngModelChange)="updateDuration()"
          appendTo="body"
          [showTime]="true" 
          [hourFormat]="24"
          [style.width]="'100%'"
          [touchUI]="isMobile"
          [showClear]="false"
          [disabled]="isDetailViewMode()"
          [showWeek]="showWeek"
          [firstDayOfWeek]="weekStartDay"
        >
        </p-calendar>
      </div>
      <div class="p-col-4">
        <label class="ml-2">{{ 'CALENDAR.DURATION' | translate }}</label>
        <input
          type="text"
          [(ngModel)]="modalTotalDuration"
          pInputText
          [style.width]="'100%'"
          [style]="{'max-width':'100%'}"
          [disabled]="true"
        />
      </div>
    </div>
    <div class="p-col-12">
      <label>Gruppen ({{ modalSelectedGroups.length }})</label>
      <br>
      <p-multiSelect [options]="modalGroups" [(ngModel)]="modalSelectedGroups" dataKey="key"
        optionLabel="label" appendTo="body"
        dataKey="id"
        [panelStyle]="{'min-width':'auto'}"
        [disabled]="false"
        [hidden]="isDetailViewMode()"
        [style]="{'width':'100%'}"
      ></p-multiSelect>
      <p-chips
        [(ngModel)]="modalSelectedGroups"
        field="label"
        variant="filled"
        separator=","
        [disabled]="true"
        [hidden]="!isDetailViewMode()"
        [style.width]="'100%'"
        [style]="{'display':'inline'}"
      ></p-chips>
    </div>
    <div class="p-col-12">
      <label>Teilnehmer ({{ modalSelectedMembers.length }})</label>
      <br>
      <p-multiSelect [options]="modalMembers" [(ngModel)]="modalSelectedMembers" dataKey="key"
        optionLabel="label" appendTo="body"
        dataKey="id"
        [panelStyle]="{'min-width':'auto'}"
        [disabled]="false"
        [hidden]="isDetailViewMode()"
        [style]="{'width':'100%'}"
      ></p-multiSelect>
      <p-chips
        [(ngModel)]="modalSelectedMembers"
        field="label"
        variant="filled"
        separator=","
        [disabled]="true"
        [hidden]="!isDetailViewMode()"
        [style.width]="'100%'"
        [style]="{'display':'inline'}"
      ></p-chips>
    </div>
  </div>
  <button 
    *ngIf="isDetailViewMode()"
    type="button"
    pButton
    icon="fa fa-trash"
    class="p-button-danger p-mr-2"
    pTooltip="{{'BUTTONS.DELETE' | translate }}"
    tooltipPosition="bottom"
    (click)="deleteEvent(modalEvent)"
  ></button>
  <div 
    style="float: right; margin: 0;"
  >
    <button 
      *ngIf="!isDetailViewMode()"
      type="button"
      pButton
      icon="fa fa-save"
      class="p-button-success p-mr-2"
      pTooltip="{{'BUTTONS.SAVE' | translate }}"
      tooltipPosition="bottom"
      (click)="finishEventModal()"
    ></button>
    <button 
      *ngIf="isDetailViewMode()"
      type="button"
      pButton
      icon="fa fa-pencil"
      class="p-button-warning p-mr-2"
      pTooltip="{{'BUTTONS.EDIT' | translate }}"
      tooltipPosition="bottom"
      (click)="editEvent(modalEvent)"
    ></button>
  </div>
  <div *ngIf="modalContent">
    {{ modalContent }}
  </div>
</p-dialog>

<ng-template #customCellTemplate let-day="day" let-locale="locale">
  <div *ngIf="day.date" class="cal-cell-top">
    <span class="cal-day-badge" *ngIf="day.badgeTotal > 0"
      >{{ day.badgeTotal }}</span
    >
    <span class="cal-day-number"
      >{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span
    >
  </div>
  <span *ngFor="let event of day.events" class="cal-events">
    <span
      class="cal-event"
      [style.background-color]="event.color.primary"
      [style.border-radius]="'10px'"
      [style.width]="event.allDay ? 'calc(100% - 4px)' : null"
      (click)="handleEvent('Clicked', event)"
      (mouseenter)="highlightDay.emit({ event: event })"
      (mouseleave)="unhighlightDay.emit({ event: event })"
      [mwlCalendarTooltip]="
        event.title | calendarEventTitle : 'monthTooltip' : event
      "
      [tooltipPlacement]="tooltipPlacement"
      [tooltipEvent]="event"
      [tooltipTemplate]="tooltipTemplate"
      [tooltipAppendToBody]="tooltipAppendToBody"
      [tooltipDelay]="tooltipDelay"
    >
    </span>
  </span>
</ng-template>